import { render, staticRenderFns } from "./SelectWinners.vue?vue&type=template&id=1202c842&scoped=true"
import script from "./SelectWinners.vue?vue&type=script&lang=js"
export * from "./SelectWinners.vue?vue&type=script&lang=js"
import style0 from "./SelectWinners.vue?vue&type=style&index=0&id=1202c842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202c842",
  null
  
)

export default component.exports